module.exports = __webpack_public_path__ + "img/reguero.8b648c2f.png";